import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IProps {
  onReject: (comment: string) => void;
  onExit: () => void;
  isOpen: boolean;
}

const ReviewRejectModal = ({ onReject, onExit, isOpen }: IProps) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  const [showValidationError, setShowValidationError] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleRejectClick = () => {
    if (comment.trim().length === 0) {
      setShowValidationError(true);
      return;
    }
    setShowConfirmModal(true);
  };

  const handleConfirmReject = () => {
    onReject(comment);
    setShowConfirmModal(false);
    setComment('');
    setShowValidationError(false);
  };

  const handleExit = () => {
    setComment('');
    setShowValidationError(false);
    setShowConfirmModal(false);
    onExit();
  };

  return (
    <>
      <Modal
        show={isOpen && !showConfirmModal}
        className="modal-large"
        centered
        onHide={handleExit}
      >
        <div className="modal-content">
          <Modal.Header className="modal-header" translate="">
            <h5 className="modal-title">
              {t('review_reject_modal_title')}
            </h5>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group">
              <label htmlFor="rejectComment">{t('review_reject_modal_comment_label')}</label>
              <textarea
                id="rejectComment"
                className="form-control"
                rows={4}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder={t('review_reject_modal_comment_placeholder')}
              />
              {showValidationError && (
                <div className="text-danger mt-2">
                  {t('review_reject_modal_validation_error')}
                </div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn action-secondary"
                    data-dismiss="modal"
                    onClick={handleExit}
                  >
                    {t('review_reject_modal_cancel')}
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    className="btn action-primary"
                    onClick={handleRejectClick}
                  >
                    {t('review_reject_modal_reject')}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        show={showConfirmModal}
        className="modal-large accept-agreement-modal data-protection-modal"
        centered
        onHide={() => setShowConfirmModal(false)}
      >
        <div className="modal-content">
          <Modal.Header className="modal-header" style={{ paddingBottom: '0' }} translate="">
            <h5 className="modal-title" style={{ textAlign: 'center', width: '100%', margin: 0 }}>
              {t('review_reject_modal_confirm_title')}
            </h5>
          </Modal.Header>

          <Modal.Footer className="modal-footer" style={{ paddingTop: '24px' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn action-secondary"
                    data-dismiss="modal"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    {t('review_reject_modal_confirm_cancel')}
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    className="btn action-primary"
                    onClick={handleConfirmReject}
                  >
                    {t('review_reject_modal_confirm_ok')}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export { ReviewRejectModal };
